import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface Props {
  questoesCertas: string;
  setQuestoesCertas: (v: string) => void;
  questoesErradas: string;
  setQuestoesErradas: (v: string) => void;
  questoesBranco: string;
  setQuestoesBranco: (v: string) => void;
  observacao: string;
  setObservacao: (v: string) => void;
}

export function FieldsQuestoes({
  questoesCertas, setQuestoesCertas,
  questoesErradas, setQuestoesErradas,
  questoesBranco, setQuestoesBranco,
  observacao, setObservacao,
}: Props) {
  return (
    <>
      <div className="grid grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label>Certas</Label>
          <Input
            type="number"
            min={0}
            value={questoesCertas}
            onChange={(e) => setQuestoesCertas(e.target.value)}
            placeholder="0"
          />
        </div>
        <div className="space-y-2">
          <Label>Erradas</Label>
          <Input
            type="number"
            min={0}
            value={questoesErradas}
            onChange={(e) => setQuestoesErradas(e.target.value)}
            placeholder="0"
          />
        </div>
        <div className="space-y-2">
          <Label>Em branco</Label>
          <Input
            type="number"
            min={0}
            value={questoesBranco}
            onChange={(e) => setQuestoesBranco(e.target.value)}
            placeholder="0"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label>Observação (opcional)</Label>
        <Textarea
          value={observacao}
          onChange={(e) => setObservacao(e.target.value)}
          placeholder="Anotações sobre a sessão..."
          rows={2}
          className="resize-none"
        />
      </div>
    </>
  );
}
